import 'cropperjs/dist/cropper.css'
import * as React from 'react'
import styled from 'styled-typed'
import Cropper from 'cropperjs'

const Canvas = styled.img`
    display: block;
    max-width: 100%;
`

interface ImageCropperProps {
    id?: string
    src: string
    cropOptions?: Cropper.Options
    onCrop: (cropper: Cropper) => void
}

export const ImageCropper = ({ id, src, onCrop, cropOptions }: ImageCropperProps) => {
    const imgEl = React.useRef(null)
    const cropperRef = React.useRef<Cropper | null>(null)

    React.useEffect(() => {
        const img = imgEl.current
        if (!img) {
            return
        }
        const cropper = new Cropper(img, {
            ...cropOptions,
            crop: () => {
                if (cropperRef.current) {
                    onCrop(cropperRef.current)
                }
            },
        })
        cropperRef.current = cropper
        return () => {
            cropper.destroy()
            cropperRef.current = null
        }
    }, [imgEl.current])

    return <Canvas id={id} src={src} ref={imgEl} />
}
